const config = {
  url: '/tag/:id',
  getTitle: id => id === 'create' ? 'Создание тега' : 'Редактирование тега',
  getApiUrl: id => id === 'create' ? '/tags' : `/tags/${id}`,
  type: 'card',
  access: ['*'],
  tabs: [
    {
      key: 'common',
      title: 'Общее',
      children: {
        left: [
          {
            key: 'name',
            title: 'Название',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
        ],
        right: [
          {
            key: 'name_en',
            title: 'Название (En)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
        ],
        both: [],
      }
    }
  ]
}

export default config
